import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffCrudLeads = () => import('./staff/crudLeads')
const ViewStaffCrudLeadsSellers = () => import('./staff/crudLeadsSellers')
const ViewStaffDetailLeads = () => import('./staff/detailLeads') 
const ViewStaffCrudCategories = () => import('./staff/crudCategories')
const ViewStaffCrudLostMotive = () => import('./staff/crudLostMotive')
const ViewStaffCrudSource = () => import('./staff/crudSource')
const ViewStaffCrudContract = () => import('./staff/crudContract')
const ViewStaffCrudLeadsServices = () => import('./staff/crudLeadsServices')

const ViewPublicApproval = () => import('./public/approval')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'SalesFlowStaffDashboard',
  crudLeads: 'SalesFlowStaffCrudLeads',
  crudLeadsSellers: 'SalesFlowStaffCrudLeadsSellers',
  detailLeads: 'SalesFlowStaffDetailLeads',
  crudCategories: 'SalesFlowStaffCrudCategories',
  crudLostMotive: 'SalesFlowStaffCrudLostMotive',
  crudSource: 'SalesFlowStaffCrudSource',
  crudContract: 'SalesFlowStaffCrudContract',
  crudLeadsServices: 'SalesFlowStaffCrudLeadsServices',
}

const router =
  [
    {
      path: '/pu/sales-flow-leads/:leadsID/approval',
      component: { render (c) { return c('router-view') }},
      children: [
        {
          path: '',
          name: 'SalesFlowPublicApproval',
          component: ViewPublicApproval,   
          meta: {
            title: 'Aprobación de cuenta',
          }                                       
        },
      ]
    },

    {
      path: '/st/sales-flow-leads',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'CRM',
          }                                
        },    
        {
          path: 'leads',
          name: VIEWS.crudLeads,
          component: ViewStaffCrudLeads,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'CRM - Oportunidades',
          }                                
        },    
        {
          path: 'leads-sellers',
          name: VIEWS.crudLeadsSellers,
          component: ViewStaffCrudLeadsSellers,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'CRM - Oportunidades',
          }                                          
        },    
        {
          path: 'leads-detail/:leadsID/view',
          name: VIEWS.detailLeads,
          component: ViewStaffDetailLeads,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'CRM - Detalle de oportunidad',
          }                                          
        },                     
        {
          path: 'categories',
          name: VIEWS.crudCategories,
          component: ViewStaffCrudCategories,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'CRM - ABM categorías',
          }                                          
        },                             
        {
          path: 'lost-motive',
          name: VIEWS.crudLostMotive,
          component: ViewStaffCrudLostMotive,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'CRM - ABM motivos de pérdida',
          }                            
        },                             
        {
          path: 'source',
          name: VIEWS.crudSource,
          component: ViewStaffCrudSource,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'CRM - ABM origen',
          }                            
        },  
        {
          path: 'contract',
          name: VIEWS.crudContract,
          component: ViewStaffCrudContract,
          beforeEnter: Permisos.IS_PERSONAL,
        },    
        {
          path: 'leads-services',
          name: VIEWS.crudLeadsServices,
          component: ViewStaffCrudLeadsServices,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'CRM - Oportunidades',
          }             
        },                                                             
      ]
    },

    {
      path: '/cu/sales-flow-leads',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/sales-flow-leads',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
export { VIEWS }
